import React from 'react'
import { Icon } from 'antd'
import ConsolidatedOrderForm from './components/consolidated-order-form'
import {
  renderOpenAnaliticPdfButton,
  renderOpenPdfButton,
} from './entities/pdf-actions'
import { groupConsolidatedOrdersByOrder } from './entities/group-consolidated-order-versions'
import { renderConsolidatedOrderVersions } from './entities/consolidated-order-versions-table'

export default {
  fields: [],
  submit: {
    collection: 'ConsolidatedOrder',
  },
  schema: [
    {
      title: 'Código PCM',
      key: 'code',
      dataIndex: 'code',
      type: 'text',
      align: 'center',
    },
    {
      title: 'Pedido',
      key: 'order_code',
      dataIndex: 'order_code',
      type: 'text',
      align: 'center',
    },
    {
      title: 'Versão',
      key: 'version',
      dataIndex: 'version',
      type: 'text',
      align: 'center',
      width: '80px',
    },
    {
      title: 'Cliente',
      key: 'order_snapshot',
      dataIndex: 'order_snapshot',
      type: 'render',
      align: 'center',
      render: (snapshot) => (snapshot && (snapshot.name_client || snapshot.social_reason)) || '—',
    },
    {
      title: 'Obra',
      key: 'order_snapshot_work',
      dataIndex: 'order_snapshot',
      type: 'render',
      align: 'center',
      render: (snapshot) => (snapshot && snapshot.name_work) || '—',
    },
    {
      title: 'PDF',
      key: 'pdf',
      dataIndex: 'pdf',
      align: 'center',
      width: '70px',
      render: (_, row) => renderOpenPdfButton(row),
    },
    {
      title: 'PDF Analítico',
      key: 'pdfAnalitic',
      dataIndex: 'pdfAnalitic',
      align: 'center',
      width: '100px',
      render: (_, row) => renderOpenAnaliticPdfButton(row),
    },
  ],
  'title-module': 'Pedido Consolidado',
  'title-navigation': (
    <div>
      <Icon type="file-done" /> Pedido Consolidado
    </div>
  ),
  module: 'ConsolidatedOrder',
  'router-base': '/panel/pedido-consolidado',
  hideCopyBtn: true,
  hideCreateBtn: true,
  groupRows: groupConsolidatedOrdersByOrder,
  expandedRowRender: renderConsolidatedOrderVersions,
  EntireFormComponent: (Module, routerProps) => (
    <ConsolidatedOrderForm module={Module} routerProps={routerProps} />
  ),
}
